"use strict";

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Provider = ({
  appConfig,
  children
}) => {
  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: {
      appConfig
    }
  }, children);
};

Provider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.any,
  appConfig: _propTypes.default.object.isRequired
} : {};
var _default = Provider;
exports.default = _default;
module.exports = exports.default;